<script lang="ts">
import type { PropType } from 'vue';
import { Image } from '@imagekit/vue';
import { ImageModel } from '../types/image.types';

export default {
  name: 'ImageView',
  components: { Image },
  props: {
    file: Object as PropType<ImageModel>,
    width: Number,
    height: Number,
  },
  computed: {
    imageKitEndpoint() {
      return window.systemConfig.imageKitEndpoint;
    },
  },
};
</script>

<template>
  <Image
    :url-endpoint="imageKitEndpoint"
    :src="file.url || file.smallUrl"
    :width="width"
    :transformation="[
      { width, height: file.fitIntoFrame ? undefined : height },
    ]"
    :queryParameters="{ v: file.updatedAt }"
    :alt="file.title"
  ></Image>
</template>

<style scoped lang="scss"></style>
